export const setWidgetState = (state, widgetState) => {
  return { widgetState };
};
